import { Controller } from "@hotwired/stimulus"

// Controller for showing/hiding the inline add core value form on mission page
export default class extends Controller {
  static targets = ["trigger", "form", "input"]

  show() {
    this.triggerTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    // Focus the name input
    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }

  hide() {
    this.triggerTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")
    // Reset form
    const form = this.formTarget.querySelector("form")
    if (form) form.reset()
  }
}
